import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NEVER, throwError, catchError } from 'rxjs';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  let router = inject(Router);
  return next(req).pipe(
    catchError((error) => {
      if (!!error.status && error.status === 401) {
        localStorage.clear();
        router.navigate(['/login']);
        return NEVER;
      }
      return throwError(() => error);
    })
  );
};
